/**
 * @generated SignedSource<<287dd0912650ba1110b3f69aa35971a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutShippingReducer_viewer$data = {
  readonly regionalInfo?: ReadonlyArray<{
    readonly countryCode: string | null;
    readonly zipCode: string | null;
  } | null> | null;
  readonly " $fragmentType": "checkoutShippingReducer_viewer";
};
export type checkoutShippingReducer_viewer$key = {
  readonly " $data"?: checkoutShippingReducer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutShippingReducer_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutShippingReducer_viewer"
};

(node as any).hash = "91a1fa27f5945e73ef0b19f9e9e853e1";

export default node;
